import React from "react";
import Lottie from "lottie-react-web";
import { makeStyles } from "@material-ui/styles";
import notFound from "../../lottie/notFound";
const useStyles = makeStyles(({
  typography
}) => ({
  lottieContainer: {
    position: "relative",
    width: typography.pxToRem(190),
    height: typography.pxToRem(182),
    overflow: "hidden"
  }
}));

const NotFound = () => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.lottieContainer
  }, /*#__PURE__*/React.createElement(Lottie, {
    width: "441px",
    height: "456px",
    style: {
      position: "absolute",
      transform: "translate(-130px, -170px)"
    },
    options: {
      animationData: notFound,
      autoPlay: true
    }
  }));
};

export default NotFound;